// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6l-0";
export var startPickingButton = "_6l-1";